import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { Seo } from '../components/Seo';
import { SITE } from '../data/seoData';
import { BLOG_POSTS } from '../data/blogData';

export default function Blog() {
  return (
    <div className="min-h-screen bg-white" data-testid="blog-index-page">
      <Seo
        title="Printing Guides & How-Tos — The Evergreen Blog | Evergreen Graphics Group"
        description="Practical guides from a working print shop: sticker size guides, label application how-tos, material comparisons and more for makers and brands."
        path="/blog"
      />

      <section className="bg-[#F4F7F2]">
        <div className="max-w-5xl mx-auto px-6 py-14 md:py-20">
          <p className="text-sm font-semibold uppercase tracking-widest text-[#4A7C59] mb-3">The Evergreen Blog</p>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#14281D]">
            Printing Guides & How-Tos
          </h1>
          <p className="mt-4 text-base md:text-lg text-[#1F3D2C]/80 max-w-2xl">
            Practical answers from a working print shop — sizing, materials, application technique and everything between your artwork and a finished product.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-card-${post.slug}`}
              className="group bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#6FBF73] hover:shadow-lg transition-all p-6 flex flex-col"
            >
              <span className="inline-flex self-start px-2.5 py-1 rounded-full bg-[#E8F1E6] text-[#2F5D3A] text-xs font-semibold mb-4">
                {post.tag}
              </span>
              <h2 className="text-base md:text-lg font-bold text-[#14281D] group-hover:text-[#2F5D3A] transition-colors leading-snug mb-2">
                {post.title}
              </h2>
              <p className="text-sm text-[#1F3D2C]/70 leading-relaxed flex-1">{post.excerpt}</p>
              <div className="mt-5 flex items-center justify-between text-xs text-[#4A7C59]">
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {post.readTime}</span>
                <span className="font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                  Read <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <footer className="bg-[#14281D] text-white py-10 mt-8">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-emerald-100">© 2026 {SITE.name}. All rights reserved.</p>
          <p className="text-sm text-emerald-200/80 mt-2">
            {SITE.address.street}, {SITE.address.city}, {SITE.address.region} {SITE.address.postal}
          </p>
          <p className="text-sm text-emerald-200/80 mt-1">Phone: {SITE.phone} | Email: {SITE.email}</p>
        </div>
      </footer>
    </div>
  );
}
